'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Convert options array of strings to objects
 */
var normalizeOptions = function normalizeOptions(options) {
  if (typeof options[0] === 'string') {
    return options.map(function (option) {
      return {
        label: option,
        value: option
      };
    });
  }

  // Pass array of objects as is
  return options;
};

exports.default = normalizeOptions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/helpers/normalizeOptions.js
// module id = 510
// module chunks = 0